import { FC } from 'react';
import { IconProps } from '../../types';

export const VkIcon: FC<IconProps> = ({ width = 24, height = 24, ...props }) => {
  return (
    <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M0 11.52C0 6.08942 0 3.37414 1.68707 1.68707C3.37414 0 6.08942 0 11.52 0H12.48C17.9106 0 20.6259 0 22.3129 1.68707C24 3.37414 24 6.08942 24 11.52V12.48C24 17.9106 24 20.6259 22.3129 22.3129C20.6259 24 17.9106 24 12.48 24H11.52C6.08942 24 3.37414 24 1.68707 22.3129C0 20.6259 0 17.9106 0 12.48V11.52Z'
        fill='#0077FF'
      />
      <path
        d='M12.7714 17.2972C7.30137 17.2972 4.18139 13.5472 4.05139 7.30713H6.79139C6.88139 11.8871 8.90135 13.8271 10.5013 14.2272V7.30713H13.0814V11.2571C14.6614 11.0871 16.3212 9.28714 16.8812 7.30713H19.4612C19.0312 9.74714 17.2313 11.5471 15.9513 12.2871C17.2313 12.8871 19.2814 14.4571 20.0614 17.2972H17.2213C16.6113 15.3972 15.0913 13.9272 13.0814 13.7272V17.2972H12.7714Z'
        fill='white'
      />
    </svg>
  );
};
